import 'twin.macro';
import { ReactNode } from 'react';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { useAIWrapperContext } from '../AIWrapperContext';

interface Props {
  children: ReactNode;
  className?: string;
}

export function AIActions({ children, className }: Props) {
  const { aiHook } = useAIWrapperContext();
  const { isLoading, stop } = aiHook;

  return (
    <div className={className}>
      <div tw="flex items-center gap-x-2">
        {isLoading && (
          <Button
            icon={NoSymbolIcon}
            minimal
            onClick={stop}
            aria-label="Stop generation"
          />
        )}
        <div
          onMouseDown={e => {
            // Prevent blur when clicking on dropdown or buttons
            e.preventDefault();
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
